import type { Tag, TagType } from '@conversia/shared-types';
import { api } from './client';

/** Endpoints de etiquetas. Prefijo: /api/tags */

export const listTags = (type?: TagType) =>
  api.get<Tag[]>('/api/tags', { query: { type } });

export const createTag = (input: { name: string; type: TagType; color?: string }) =>
  api.post<Tag>('/api/tags', input);

export const deleteTag = (id: string) => api.del<{ success: boolean }>(`/api/tags/${id}`);
